import React, { useEffect } from 'react';
import * as actions from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Spin, Empty, Input, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const AllNesaMembership = ({ memberships, membershipsLoading, getEagleNesaMemberships, nesa_levels }) => {
    useEffect(() => {
        getEagleNesaMemberships();
    }, [getEagleNesaMemberships]);

    const renderMemberships = () => {
        if (membershipsLoading) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin tip="Loading NESA Membership..." className='loading-state' indicator={<LoadingOutlined spin />} />
                    </Col>
                </Row>
            );
        }

        // Check if there are no memberships or no registrations across all memberships
        if (!memberships || memberships.length === 0 || memberships.every(member => member.nesaRegistrations.length === 0)) {
            return <Empty description="No NESA Membership" className='loading-state' />;
        }

        return memberships.map((membership) => {
            const validRegistrations = membership.nesaRegistrations.filter(
                registration => registration.effectiveDate || registration.expireDate
            );

            return (
                <div key={membership.memberId} className='membership-entry'>
                    <Row className='membership-row'>
                        {validRegistrations.length > 0 ? (
                            <div>
                                {validRegistrations.map((registration) => {
                                    const level = nesa_levels.find(level => level.id === String(registration.programId));
                                    const membershipName = level ? level.name : "";

                                    return (
                                        <div key={registration.personPositionId} className='registration-entry'>
                                            <Row className='membership-row'>
                                                <Col span={5} className='memberID-div'>
                                                    <h3 className='membershipID'>MID: {membership.memberId}</h3>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="NESA membership level:">
                                                        <Input value={membershipName} disabled />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Effective Date:">
                                                        <Input value={registration.effectiveDate} disabled />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item label="Expire Date:">
                                                        <Input value={registration.expireDate || ''} placeholder='YYYY/MM/DD' disabled />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className='empty-style' style={{ display: 'none' }} />
                        )}
                    </Row>
                </div>
            );
        });
    };

    return (
        <div className='nesaMembership-widget-content margin-bottom-20'>
            <fieldset>
                <legend className='all-nesa-membership'>ALL NESA MEMBERSHIP :</legend>
                <div className='membership-div'>
                    {renderMemberships()}
                </div>
            </fieldset>
        </div>
    );
};

const mapStateToProps = (state) => ({
    memberships: state.eagleNesaMembershipsReducer.memberships,
    membershipsLoading: state.eagleNesaMembershipsReducer.loading,
    nesa_levels: state.nesalevelsreducer.levels,
    error: state.eagleNesaMembershipsReducer.error,
});

const mapDispatchToProps = (dispatch) => ({
    getEagleNesaMemberships: () => dispatch(actions.getEagleNesaMemberships()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(AllNesaMembership)));


// WEBPACK FOOTER //
// ./src/components/MyProfile/AllNesaMembership.js